import authInstance from 'config/axios.config';

export const serviceServices = {
  getServices: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== 'all' && value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/seller-service/admin?${params}`);
    return res.data;
  },

  getServiceById: async (serviceId) => {
    const res = await authInstance.get(`/seller-service/${serviceId}`);
    return res.data;
  },

  addService: async (payload) => {
    const res = await authInstance.post('/seller-service/add', payload);
    return res.data;
  },

updateService: async ({ serviceId, data }) => {
  const res = await authInstance.put(
    `/seller-service/admin/update/${serviceId}`,
    data
  );

  return res.data;
},

  deleteService: async (serviceId) => {
    const res = await authInstance.delete(`/seller-service/admin/${serviceId}`);
    return res.data;
  },

  updateServiceStatus: async ({ serviceId, payload }) => {
    const res = await authInstance.patch(`/seller-service/admin/status/${serviceId}`, payload);
    return res.data;
  },

  uploadVideo: async (file) => {

  const formData =
    new FormData();

  formData.append(
    'file',
    file
  );

  const res =
    await authInstance.post(

      '/admin/upload',

      formData,

      {
        headers:{
          'Content-Type':
          'multipart/form-data'
        }
      }

    );

  return res.data;
},

exportServices: async ({
  categoryId,
  subcategoryId,
  approvalStatus,
  isActive,
  sellerId,
  search,
   sortBy,
  sortOrder,
}) => {
  const params =
    new URLSearchParams({
      categoryId:
        categoryId || '',

      subcategoryId:
        subcategoryId || '',

      approvalStatus:
        approvalStatus === 'all'
          ? ''
          : approvalStatus || '',

      isActive:
        isActive === 'all'
          ? ''
          : isActive || '',

      sellerId:
        sellerId || '',

      search:
        search || '',

        sortBy: sortBy || '',

  sortOrder: sortOrder || '',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return authInstance.get(
    `/seller-service/admin/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};
